// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_0gr","cls2":"FriendlySutdModal-cls2_NVw FriendlySutdModal-cls1_0gr"};